import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'yo-egalim-root',
    templateUrl: './egalim-root.component.html',
    styleUrls: ['./egalim-root.component.scss'],
    standalone: false
})
export class EgalimRootComponent implements OnInit {

  ngOnInit(): void {
  }

}
